import { createContext, useMemo, useState } from 'react';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import styled from 'styled-components';
import ChevronIcon from '../icons/ChevronIcon';
import DropPinButton from '../map-toolbars/buttons/DropPinButton';

const MobileCard = styled(Card)`
  position: absolute;
  z-index: 200;
  left: 0;
  right: 0;
  bottom: ${({ bottom }) => bottom};
  height: ${({ $expanded, bottom }) =>
    $expanded ? `calc(100% - ${bottom})` : '35vh'};
  min-height: 180px;
  transition: height 0.3s ease-in-out;
  border: 1px solid var(--border-color);
  border-radius: ${({ $expanded }) => ($expanded ? '0' : '8px 8px 0px 0px')};
  background-color: var(--background-color);
  padding: 0;
`;

const MobileCardHeader = styled(CardHeader)`
  background-color: var(--background-color);
  h3 {
    padding: 0 var(--side-panel-padding);
  }
`;

export const MobilePanelContext = createContext({
  setMobilePanelExpanded: () => {},
  mobilePanelExpanded: false,
});

const MobilePanel = ({
  children,
  onClose,
  title,
  scrollingContainerRef,
  bottom = '0px',
}) => {
  const [expanded, setExpanded] = useState(false);
  const contextValue = useMemo(
    () => ({
      mobilePanelExpanded: expanded,
      setMobilePanelExpanded: setExpanded,
    }),
    [expanded],
  );

  return (
    <MobilePanelContext.Provider value={contextValue}>
      <MobileCard $expanded={expanded} bottom={bottom}>
        <MobileCardHeader
          className="d-flex justify-content-between align-items-center px-3"
          color="white"
        >
          <h3 className="m-0">{title}</h3>
          <DropPinButton className="ml-auto" />
          <div>
            <Button
              color="link"
              onClick={() => setExpanded(!expanded)}
              size="sm"
            >
              <ChevronIcon
                width={16}
                height={16}
                direction={expanded ? 'down' : 'up'}
              />
            </Button>
            {onClose && (
              <Button color="link" onClick={onClose} size="sm" className="ml-2">
                ✕
              </Button>
            )}
          </div>
        </MobileCardHeader>
        <CardBody className="overflow-hidden p-0">
          <div
            className="overflow-auto h-100 px-3 py-2"
            ref={scrollingContainerRef}
          >
            {children}
          </div>
        </CardBody>
      </MobileCard>
    </MobilePanelContext.Provider>
  );
};

export default MobilePanel;
